// Adapters
import notificationsAdapter from 'adapters/notifications';

// Utils
import http from 'utils/http';
import { getQueryString } from 'utils/common';

export const getCategories = async queryObj => {
  const queryStr = getQueryString(queryObj);

  try {
    const response = await http.get(
      `payout/settings/emailNotifications?${queryStr}`,
    );
    return notificationsAdapter.from(response.settings);
  } catch (error) {
    return {
      error,
    };
  }
};

export const addNewRecipient = async (queryObj, body) => {
  const queryStr = getQueryString(queryObj);

  try {
    const response = await http.post(
      `payout/settings/emailNotifications?${queryStr}`,
      body,
    );
    return response;
  } catch (error) {
    return {
      error,
    };
  }
};

export const removeRecipient = async (queryObj, body) => {
  const queryStr = getQueryString(queryObj);

  try {
    const response = await http.delete(
      `payout/settings/emailNotifications/recipient?${queryStr}`,
      { data: body },
    );
    return response;
  } catch (error) {
    return {
      error,
    };
  }
};

export const toggleCategory = async (queryObj, body) => {
  const queryStr = getQueryString(queryObj);

  try {
    const response = await http.post(
      `payout/settings/emailNotifications/toggle?${queryStr}`,
      body,
    );
    return response;
  } catch (error) {
    return {
      error,
    };
  }
};
